import { render, staticRenderFns } from "./MenuProfilesDashboard.vue?vue&type=template&id=7cbf0ada"
import script from "./MenuProfilesDashboard.vue?vue&type=script&lang=js"
export * from "./MenuProfilesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports